import { render } from "./car_0.vue?vue&type=template&id=107a4736&scoped=true"
const script = {}

import "./car_0.vue?vue&type=style&index=0&id=107a4736&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107a4736"]])

export default __exports__